<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item v-if="showForm === false || firstCreate">
        <el-row class="content">
          <el-col :span="24">
            <el-radio v-model="form.type" label="2">
              <i class="ico ico-wechatpay"></i>
              <span style="font-weight: normal;margin-left: 5px;">微信支付</span>
            </el-radio>
          </el-col>
          <el-col :span="24">
            <el-radio v-model="form.type" label="3">
              <i class="ico ico-alipay"></i>
              <span style="font-weight: normal;margin-left: 5px;">支付宝</span>
            </el-radio>
          </el-col>
          <!--<el-col :span="24">
            <el-radio v-model="form.type" label="11">
              <i class="ico ico-wechatpay"></i>
              <span style="font-weight: normal;margin-left: 5px;">AlphaPay-微信</span>
            </el-radio>
          </el-col>
          <el-col :span="24">
            <el-radio v-model="form.type" label="12">
              <i class="ico ico-alipay"></i>
              <span style="font-weight: normal;margin-left: 5px;">AlphaPay-支付宝</span>
            </el-radio>
          </el-col>
          <el-col :span="24">
            <el-radio v-model="form.type" label="13">
              <i class="ico ico-offpay"></i>
              <span style="font-weight: normal;margin-left: 5px;">AlphaPay-银联</span>
            </el-radio>
          </el-col>-->
          <el-col :span="24" v-if="single_id != 0 && showOffPay && payment_way==1">
            <el-radio v-model="form.type" label="0">
              <i class="ico ico-offpay"></i>
              <span style="font-weight: normal;margin-left: 5px;">私下支付</span>
            </el-radio>
          </el-col>
          <el-col :span="24" v-if="company_account =='1'">
            <el-radio v-model="form.type" label="20">
              <i class="ico ico-company"></i>
              <span style="font-weight: normal;margin-left: 5px;">悦单支付</span>
            </el-radio>
          </el-col>
          <!--<el-col :span="24">
            <el-radio v-model="form.type" label="4">
              <i class="ico ico-paypal"></i>
              <span style="font-weight: normal;margin-left: 5px;">Paypal</span>
            </el-radio>
          </el-col>-->
          <!--<el-col :span="24">
            <el-radio v-model="form.type" label="1">
              <i class="ico ico-mastercard" style="margin-right: 3px;"></i>
              <i class="ico ico-visa" style="margin-right: 3px;"></i>
              <i class="ico ico-unionpay" style="margin-right: 3px;"></i>
            </el-radio>
          </el-col>-->
        </el-row>
      </el-form-item>
      <el-form-item v-if="form.type == 1 && showForm !== false" prop="card_number">
        <YueDanIpt model="card_number" :object="form" placeholder="信用卡号"></YueDanIpt>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item v-if="form.type == 1 && showForm !== false" prop="valid_date">
            <YueDanIpt model="valid_date" :object="form" placeholder="有效期"></YueDanIpt>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="form.type == 1 && showForm !== false" prop="safety_code">
            <YueDanIpt model="safety_code" :object="form" placeholder="安全码"></YueDanIpt>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if="form.type == 1 && showForm !== false" prop="name">
        <YueDanIpt model="name" :object="form" placeholder="持卡人姓名"></YueDanIpt>
      </el-form-item>
      <PaymentList v-on:changePayment="changePayment" v-if="form.type == 1 && showForm === false"></PaymentList>
      <div v-if="form.type == 1 && showForm === false" class="mt10 add-credit">
        <span class="pointer" @click="addPayment()"><i class="ico ico-add"></i> <span class="add-tip">添加信用卡</span></span>
      </div>
      <el-form-item>
        <el-button class="block" :type="btnType || 'info'" @click="submit()" :loading="loading">{{btnTxt || '确定'}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import YueDanIpt from '../../../components/YueDanIpt'
import api from '../../../services/api.js'
import PaymentList from './PaymentList'


export default {
  name: 'AddPayment',
  props: ['addressInfo', 'btnType', 'showForm', 'firstCreate', 'paymentId', 'btnTxt', 'newWindow','singleID',"showOffPay","company_account","payment_way"],
  computed: {
    taskInfo () {

	    return this.$store.state.taskInfo
    }
  },
  created () {
      console.log(this.paymentId)
      console.log(this.singleID)
      if(this.taskInfo.conditions){
        this.single_id = this.taskInfo.conditions.single_id
      }else {
        this.single_id = this.singleID
      }
      console.log(this.single_id)
    if (this.showForm === false) {
      setTimeout(() => {
        this.form.type = this.paymentId || this.taskInfo.payment_type_info.type
      })
    }
  },
  components: {
    YueDanIpt: YueDanIpt,
    PaymentList: PaymentList
  },
  data () {
    return {
      loading: false,
      editPaymentInfo: null,
      single_id: null,
      form: {
        type: null, //0私下支付、1信用卡or储蓄卡、2微信、3支付宝、4PapPal
        card_number: null, //卡号[type为1时]
        valid_date: null, //有效期[type为1时]
        safety_code: null, //安全码[type为1时]
        name: null, //持卡人姓名[type为1时]
      },
      rules: {
        card_number: [
          { required: true, message: '卡号是必填项', trigger: 'blur' }
        ],
        valid_date: [
          { required: true, message: '有效期是必填项', trigger: 'blur' }
        ],
        safety_code: [
          { required: true, message: '安全码是必填项', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '持卡人姓名是必填项', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    addPayment () {
      this.$emit('addPayment')
    },
    changePayment (paymentInfo) {
      this.editPaymentInfo = paymentInfo
    },
    selectNewPayment () {
      this.taskInfo.payment_type_id = this.editPaymentInfo.payment_type_id
      this.taskInfo.payment_type_info = this.editPaymentInfo.payment_type_info
      this.$store.commit('updateTaskInfo', this.taskInfo)
      this.$emit('success', this.form)
    },
    async submit () {
      /*if (this.form.type > 4 && this.form.type != '20') {
        return
      }*/
      if (this.newWindow) {
        this.$emit('success', {
          type: this.form.type,
          newWindow: this.form.type == 3 ? window : ''
        })
        return;
      }
      if (this.paymentId) {
        this.$emit('success', this.form)
        return
      }
      if (this.showForm === false && this.form.type == 1) {
        this.selectNewPayment()
        this.$store.commit('updateTaskInfo', this.taskInfo)
        this.$emit('success', this.form)
        return;
      }
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (!valid) {
          return false;
        }
        let id = await this.savePayment()
        this.taskInfo.payment_type_info = this.form
        this.taskInfo.payment_type_id = id
        if(id == 0){
          this.taskInfo.offline_payment = 1
        }else{
          this.taskInfo.offline_payment = 0
        }
        this.$store.commit('updateTaskInfo', this.taskInfo)
        this.$emit('success', this.form)
      })
    },
    async savePayment () {
      let apiPayment = 'add_payment_type';
      if (this.form.id) {
        apiPayment = 'update_payment_type';
        this.form.payment_type_id = this.form.id
      }
      let res = await api.post(this, {
        path: 'buyer.php',
        api: apiPayment,
        data: this.form,
        loading: 'loading'
      });
      if (this.form.id) {
        return this.form.id
      }
      return res.body.result
    },
  }
}
</script>

<style scoped lang="scss">
.add-credit {
  color: #666;
}

.el-button {
  margin-top: 15px;
}

.el-button--primary {
  margin-top: 30px;
}
.ico-offpay {
    background-image: url('../../../ico/ic_payment_cash.png');
    background-size: cover;
    width: 24px;
    height: 24px;
}
// .content {
//   padding: 0px 105px;
// }

@media screen and (max-width:760px){
  // .content {
  //   padding: 0px 120px !important;
  // }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/payment/Form.vue